import React, { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './SidePanel.scss'
import { useOutsideClick } from '../../../hooks/useOutsideClick'
import { clearSidePanel } from '../../../redux/sidePanel/sidePanelSlice'
import EncounterPanel from './EncounterPanel'
import { getEncounter } from '../../../redux/sidePanel/sidePanelThunk'
import { getDemographics } from '../../../redux/demographics/demographicsThunk'
import NotePanel from './NotePanel'
import { getIsAi, shouldShowNoteIcon } from '../../../utils/sharedFeaturesFunctions'
import { getChartValidations } from '../../../helper/chartValidationHelper'
import { getIsNoteRequired } from '../../../utils/sharedChartFunctions'

// areas where if we click, we do not want to close the side panel
const IGNORE_CLICK_AREAS_CLASSES = [
  'mbsc-',
  'modal',
  'fullscreen',
  'loader',
  'mbsc-button-icon',
  'mbsc-date-box',
  'NUSAI_animated',
]

export default function SidePanel() {
  const dispatch = useDispatch()
  const encounterId = useSelector((state) => state.sidePanel.panelChargeId)
  const panelChart = useSelector((state) => state.sidePanel.panelChart)
  const isSaving = useSelector((state) => state.sidePanel.isSaving)

  const features = useSelector((state) => state.user.features) || []
  const practice = useSelector((state) => state.user.practice)
  const provider = useSelector((state) => state.user.provider)
  const roles = useSelector((state) => state.user.roles) || []

  const foolishSaveNoteRefDrill = useRef(null)

  useEffect(() => {
    if (encounterId) {
      dispatch(getEncounter(encounterId))
    }
  }, [dispatch, encounterId])

  useEffect(() => {
    dispatch(getDemographics())
    getChartValidations()

    return () => {
      dispatch(clearSidePanel())
    }
  }, [dispatch])

  const ref = useRef(null)
  useOutsideClick(ref, (e) => {
    if (
      IGNORE_CLICK_AREAS_CLASSES.every((area) => !e?.srcElement?.className?.includes?.(area)) &&
      IGNORE_CLICK_AREAS_CLASSES.every((area) => !e?.srcElement?.closest('.' + area))

      // !e.srcElement?.className?.includes('mbsc-') &&
      // !e.srcElement?.className?.includes('modal')
    ) {
      if (foolishSaveNoteRefDrill.current) {
        foolishSaveNoteRefDrill.current?.().then(() => {
          dispatch(clearSidePanel())
        })
      } else {
        dispatch(clearSidePanel())
      }
    }
  })

  if (!encounterId || !getIsAi()) {
    return null
  }

  return (
    <div id={'SidePanel'} ref={ref}>
      <div className={'closePanelIcon'}>
        {isSaving ? (
          <i className="fa-duotone fa-solid fa-spinner-third fa-spin"></i>
        ) : (
          <i
            className="far fa-xmark"
            onClick={() => {
              if (foolishSaveNoteRefDrill.current) {
                foolishSaveNoteRefDrill.current?.().then(() => {
                  dispatch(clearSidePanel())
                })
              } else {
                dispatch(clearSidePanel())
              }
            }}
          ></i>
        )}
      </div>
      {(shouldShowNoteIcon(features, { chart: panelChart }) ||
        getIsNoteRequired(practice, provider, roles)) && (
        <NotePanel saveNoteRef={foolishSaveNoteRefDrill} />
      )}
      <div id={'Side-Encounter-Panel'}>
        <EncounterPanel />
      </div>
    </div>
  )
}
